import { observer } from 'mobx-react-lite';
import { SubscriptionStatusTypes } from 'config/types';
import { useSubscription } from 'state';
import SubscriptionStatus from '../SubscriptionStatus';

/**
 * SubscriptionStatusProperties
 *
 * @return {JSX.Element}
 */
const SubscriptionStatusProperties = ({ className }) => {
  const { data } = useSubscription();
  const status = data?.status;

  return status &&
    (status === SubscriptionStatusTypes.freeTrial ||
      status === SubscriptionStatusTypes.cancelled) ? (
    <SubscriptionStatus
      title="SUBSCRIPTION"
      freeTrialDescription="Try out Propa for free with your first property on us."
    />
  ) : null;
};

SubscriptionStatusProperties.displayName = 'SubscriptionStatusProperties';

export default observer(SubscriptionStatusProperties);
